type TypeErrorHandler = (message: string) => void;

let handler: TypeErrorHandler | null = null;

export const setGlobalErrorHandler = (fn: TypeErrorHandler): void => {
  handler = fn;
};

export const showGlobalError = (message: string): void => {
  handler?.(message);
};
